module.exports = __webpack_public_path__ + "img/distance.ecab76a3.svg";